<template>
  <div class="treeview">
    <tree-view-entry
      v-for="entry of parsedEntries"
      :key="entry.code"
      :level="0"
      :height="entryHeight"
      :entry="entry"
      :visible="entry.visible"
      :no-icon="noIcon"
      :no-check-icon="noCheckIcon"
      :entry-state-change="entryStateChange"
    >
      <template v-slot="_">
        <slot :vm="_.vm" :entry="_.entry">{{ _.entry.name }}</slot>
      </template>
    </tree-view-entry>
  </div>
</template>

<script>
import TreeViewEntry from '@/components/treeview/TreeViewEntry.vue'

/**
 * Get ID assigned to each entry when not specified
 */
// let psuedoId = 0
// function getId() {
//   const id = psuedoId.toString()
//   psuedoId++
//   return id
// }

export default {
  components: {
    TreeViewEntry,
  },
  props: {
    entries: {
      type: Array,
      default: () => [],
    },
    noIcon: {
      type: Boolean,
      default: false,
    },
    noCheckIcon: {
      type: Boolean,
      default: false,
    },
    entryStateChange: {
      type: Function,
      default: () => {},
    },
    entryHeight: {
      type: Number,
    },
  },
  computed: {
    parsedEntries() {
      for (const entry of this.entries) {
        this.parse(entry, false)
      }
      return this.entries
    },
  },
  methods: {
    parse(entry) {
      if (entry.children) {
        for (const child of entry.children) {
          this.parse(child)
        }
      }
      // if (!entry.hasOwnProperty('id')) {
      //   // ID does not need to be reactive since it won't change
      //   entry.id = getId()
      // }
      if (!entry.hasOwnProperty('state')) {
        let state = 'none'
        if (entry.children) {
          const states = new Set(entry.children.map(c => c.state))
          if (states.size > 1) {
            state = 'intermediate'
          } else {
            state = entry.children[0].state
          }
        }
        this.$set(entry, 'state', state)
      }
      if (!entry.hasOwnProperty('open')) {
        this.$set(entry, 'open', false)
      }
      if (!entry.hasOwnProperty('disabled')) {
        this.$set(entry, 'disabled', false)
      }
      if (!entry.hasOwnProperty('visible')) {
        this.$set(entry, 'visible', true)
      }
    },
  },
}
</script>
